module.exports = __webpack_public_path__ + "007.812e1a27.png";